import { render, staticRenderFns } from "./YoutubeButton.vue?vue&type=template&id=7fbf0c93&scoped=true&"
import script from "./YoutubeButton.vue?vue&type=script&lang=ts&"
export * from "./YoutubeButton.vue?vue&type=script&lang=ts&"
import style0 from "./YoutubeButton.vue?vue&type=style&index=0&id=7fbf0c93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbf0c93",
  null
  
)

export default component.exports